import { useEffect, useState } from "react";

export interface GoogleReview {
  author: string;
  rating: number;
  text: string;
  time: string;
}

interface ReviewsResult {
  reviews: GoogleReview[];
  rating: number | null;
  total: number | null;
  loading: boolean;
  error: boolean;
}

/**
 * Fetches Google Places reviews from the Netlify serverless function at
 * /.netlify/functions/reviews. Falls back gracefully (loading=false, reviews=[])
 * if the function is not available or env vars are not configured.
 */
export function useGoogleReviews(): ReviewsResult {
  const [reviews, setReviews] = useState<GoogleReview[]>([]);
  const [rating, setRating] = useState<number | null>(null);
  const [total, setTotal] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch("/.netlify/functions/reviews")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        setReviews(data.reviews ?? []);
        setRating(data.rating ?? null);
        setTotal(data.total ?? null);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { reviews, rating, total, loading, error };
}
